export const GET_COMMENTS = 'GET_COMMENTS';
export const COMMENT_ERROR = 'COMMENT_ERROR';
export const DELETE_COMMENT = 'DELETE_COMMENT';
export const ADD_COMMENT = 'ADD_COMMENT';
